<template>
  <view
    class="ts-button"
    wx:class="{{[activeClass,className,externClass]}}"
    wx:style="{{borderStyle}}"
    bindtap="handleClick"
    catchtap="handleCatchClick"
  >
    <slot></slot>
  </view>
</template>

<script>
  import mpx, { createComponent } from '@mpxjs/core'
  import { debounce } from '@didi/spring-base'
  const px2vw = (px) => `${(px / 750) * 100}vw`

  createComponent({
    props: {
      externClass: {
        type: String,
        value: ''
      },
      activeClass: {
        type: String,
        value: ''
      },
      disabled: {
        type: Boolean,
        value: false
      },
      borderRadius: {
        type: Number,
        value: 0
      },
      borderColor: {
        type: String,
        value: ''
      },
      externStyle: {
        type: Object,
        value: () => {}
      }
    },
    data() {
      return {
        handleClick: null,
        handleCatchClick: null,
        isXiaoMi: false
      }
    },
    created() {
      // mpx.getSystemInfo({
      //   success: (res) => {
      //     this.isXiaoMi = res.brand === 'Xiaomi'
      //   }
      // })
      this.handleClick = debounce(
        () => {
          // trackEvent('spring-ui-button-debounce-click', '按钮-防抖点击', {
          //   disabled: this.disabled
          // })
          if (this.disabled) {
            return
          }
          this.triggerEvent('click')
        },
        300,
        { leading: true, trailing: false }
      )
      this.handleCatchClick = debounce(
        () => {
          if (this.disabled) {
            return
          }
          this.triggerEvent('catchclick')
        },
        300,
        { leading: true, trailing: false }
      )
      // trackEvent('spring-ui-button-init', '按钮-初始化', {
      //   init: true,
      //   catch: this.useCatch
      // })
    },
    computed: {
      className() {
        // todo
        return ''
      },
      borderStyle() {
        if (!this.borderRadius)
          return {
            ...this.externStyle
          }
        const borderLength = 1
        return {
          ...this.externStyle,
          '--borderlg': borderLength + 'px',
          '--borderrd': px2vw(+this.borderRadius * 2),
          '--bordercl': this.borderColor || undefined
        }
      }
    },

    methods: {}
  })
</script>

<style lang="stylus" scoped>
  .ts-button
    position relative
    box-sizing border-box
    font-size 16px
    text-align center
    background-color #fff
    cursor pointer
    transition opacity 0.2s
    -webkit-tap-highlight-color transparent
    -moz-tap-highlight-color transparent
    &::after
      position absolute
      content ''
      width 200%
      height 200%
      box-sizing border-box
      border var(--borderlg) solid var(--bordercl)
      transform-origin 0 0
      transform scale(0.5)
      border-radius var(--borderrd)
      top 0
      left 0
</style>

<script name='json'>
  module.exports = {
    component: true
  }
</script>

